import { render, staticRenderFns } from "./OsobaTvrtke.vue?vue&type=template&id=26ea8fe2&scoped=true&"
import script from "./OsobaTvrtke.vue?vue&type=script&lang=js&"
export * from "./OsobaTvrtke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ea8fe2",
  null
  
)

export default component.exports